import { createContext } from "react";


export const AutoLogin = createContext();